import { HelmetProvider } from "react-helmet-async";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ContactFormProvider } from "@/contexts/ContactFormContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import ContactFormDialog from "@/components/ContactFormDialog";
import Index from "./pages/Index.tsx";
import NotFound from "./pages/NotFound.tsx";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <LanguageProvider>
          <ContactFormProvider>
            <Toaster />
            <Sonner />
            <ContactFormDialog />
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/bg" element={<Index langOverride="bg" />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </BrowserRouter>
          </ContactFormProvider>
        </LanguageProvider>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
